// extracted by mini-css-extract-plugin
export default {"main":"timeclean_main__Vb4Sm","containerflat":"timeclean_containerflat__QeUTt","section_1":"timeclean_section_1__8m3Jb"};